export const dmrCZfallback = 'dmrzfactor10';
export const defaultCZfallback = 'aerialCuzk2025';
export const defaultFallback = 'googleSatelliteMaps';

const premiumLayerFallbacks: Record<string, string> = {
  dmrMalee: dmrCZfallback,
  dmrMaleeTransformed: dmrCZfallback,
  copernicus: defaultCZfallback,
  mineralResources: defaultCZfallback,
  soilTypesLayer: defaultCZfallback,
  eagriLayer: defaultCZfallback,
  zbgisSR: defaultFallback,
  dmrMaleeSR: defaultFallback,
  touristSRLayer: defaultFallback,
  zbgisSROrto: defaultFallback,
  aerialSR2023: defaultFallback,
  aerialSR2020: defaultFallback,
  aerialSR2016: defaultFallback,
  esriArchive2023: defaultCZfallback,
  esriArchive2018: defaultCZfallback,
  esriArchive2016: defaultCZfallback,
  esriArchive2014: defaultCZfallback,
};

export const premiumLayerKeys: ReadonlySet<string> = new Set(
  Object.keys(premiumLayerFallbacks)
);

export const isPremiumLayer = (layerKey: string | null) =>
  layerKey !== null && premiumLayerKeys.has(layerKey);

export const getPremiumLayerFallback = (layerKey: string | null) => {
  if (layerKey === null) {
    return null;
  }

  return premiumLayerFallbacks[layerKey] ?? null;
};

export const resolveAccessibleLayer = (
  layerKey: string | null,
  hasPremiumAccess: boolean
) => {
  if (!isPremiumLayer(layerKey) || hasPremiumAccess) {
    return layerKey;
  }

  return getPremiumLayerFallback(layerKey);
};
